module.exports = __webpack_public_path__ + "static/media/statsWhite.3d8a5d39.svg";